import React from 'react';
import { NextPage } from 'next';
import { useSelector } from 'react-redux';
import { useAuthFlow, useMagicLinkAuthProvider, useModal } from 'hooks';
import { MarketsActions } from 'store/actions';
import { DetectMarketSelectors, MarketsSelectors } from 'store/selectors';
import { isFetchingStates } from 'store/utils';
import { UserHeader } from 'components/common/Header';
import HomepageLayout from 'components/home/HomepageLayout';
import Footer from 'components/home/Footer';
import RenderComponent from 'components/common/RenderComponent';
import ResetPasswordModal from 'components/modals/ResetPasswordModal';
import useResetPasswordProvider from 'hooks/auth/useResetPasswordProvider';
import useNeshamahDeeplinkResume from 'hooks/auth/useNeshamahDeeplinkResume';
import * as Yup from 'yup';
import withGetInitialPropsRouteValidation from '../hocs/withGetInitialPropsRouteValidation';

const querySchema = Yup.object({});

const Index: NextPage = () => {
  useAuthFlow();
  useMagicLinkAuthProvider();
  useNeshamahDeeplinkResume();
  const [showResetPasswordModal] = useModal(ResetPasswordModal);
  useResetPasswordProvider(showResetPasswordModal);

  const market = useSelector(DetectMarketSelectors.getSelectedMarket);
  const marketsState = useSelector(MarketsSelectors.marketsState);

  return (
    <>
      <UserHeader />
      <RenderComponent
        isLoading={isFetchingStates(marketsState) && !market}
        renderContent={() => <HomepageLayout markets={marketsState.entities} market={market} />}
      />
      <Footer />
    </>
  );
};

Index.getInitialProps = withGetInitialPropsRouteValidation(querySchema, async ({ store }: any) => {
  store.dispatch(MarketsActions.getMarkets.request({ params: { page_size: 100 } }));

  return {};
});

export default Index;
